import { createActions } from 'reduxsauce'
 
export const { Types, Creators } = createActions({
  loginRequest: ['vignet_number', 'pin'],
  loginSuccess: ['responseData'],
  loginFailure: ['error'],

  changePassword: ['payload', 'history'],
  changePasswordSuccess: null,
  changePasswordFailure: ['error'],

  setVignetNumber: ['vignet_number'],

  logout: null,

}, {});
